<template>
  <ul class="list-unstyled">
    <li v-for="(item, i) in exHighlights" :key="`highlights-${i}`">
      <i class="el-icon-arrow-right" /> <span>{{ item }}</span>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadHighlights',
  computed: {
    ...mapState('experience', {
      exHighlights: 'highlights',
    }),
  },
}
</script>

<style lang="scss" scoped>
.list-unstyled {
  span {
    font-size: 0.9em;
  }

  i {
    top: 0.4em;
  }
}
</style>
